import styled from 'styled-components'

export const Label = styled.label`
    padding-right: 1%;
    font-weight: 600;
    margin: 0;
    color: var(--neutralcolor-darkest);
`

export const HelpText = styled.span`
    color: var(--neutralcolor-dark);
    font-size: 0.75em;
`
